// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: replace with your own config from the Firebase console
const firebaseConfig = {
 apiKey: "AIzaSyAb4iQCdH_wQE_8RmTr9Q4xHNchjA0VtpM",
  authDomain: "floralplatform.firebaseapp.com",
  projectId: "floralplatform",
  storageBucket: "floralplatform.firebasestorage.app",
  messagingSenderId: "252467044205",
  appId: "1:252467044205:web:fbcf6526b065affeb08464"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);